


















































































































import { Prop, Component } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIcon } from '../sw-icon';

const i18nPathPrefix = 'libShared.SwSteps';

@Component({
  components:{
    SwIcon,
  },
})
export default class SwSteps extends SwExtendedVue{
  @Prop({ type: String, default: 'First Step' })
  stepTitle: string;

  @Prop(String)
  stepLabel: string;

  @Prop(Number)
  stepCount: number;

  @Prop(String)
  stepState: string;

  @Prop(Number)
  stepIndex: number;

  @Prop({ type: Boolean, default: true })
  changeStepTitle: boolean;

  @Prop(String)
  theme: string;

  i18nPathPrefix = i18nPathPrefix;

  get effectiveStepTitle(): string {
    let stepName = this.stepTitle;
    if (this.changeStepTitle) {
      if (this.stepState === 'complete') {
        stepName = String(this.$t(`${i18nPathPrefix}.completed`));
      } else {
        stepName = this.stepTitle;
      }
    }
    return stepName;
  }
}
